import "./index.css";
import { findParent, toggleClass } from "@src/utils/dom";

interface IDataset extends DOMStringMap {
  event: "expand";
}

const CONTAINER = "container-qa";
const EXPLANATION = "container-qa-explanation";
const EXPLANATION_ACTIVE = "container-qa-explanation__active";

function toggleDetail(sourceEle: HTMLHeadingElement) {
  const explanationEle = findParent(sourceEle, EXPLANATION);
  toggleClass(explanationEle, EXPLANATION_ACTIVE);
}

export function setupQA() {
  document.addEventListener("click", function (this: HTMLDivElement, e: Event) {
    const sourceEle = e.target as HTMLDivElement;
    if (sourceEle.closest(`.${CONTAINER}`)) {
      const dataSet = sourceEle.dataset as IDataset;
      if (dataSet.event === "expand") {
        toggleDetail(sourceEle);
      }
    }
  });
}
